// React router that changes between home, workbook and createbonsai
import React from "react";
// import { bonsai } from "../libs/fakeDesignData";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import DesignerSite from "../../components/Designer/Site";

function ScreenDesignerSite() {
  const navigate = useNavigateToTop();

  return <DesignerSite />;
}

export default ScreenDesignerSite;
